/* eslint-disable */
require('./arrow-left')
require('./arrow-right')
require('./burger')
require('./fb')
require('./ig')
require('./logo-small')
require('./logo')
require('./map-bg')
require('./perso-1')
require('./perso-2')
require('./perso-3')
require('./persos')
require('./persos2')
require('./vm')
require('./volume-off')
require('./volume-on')
